import { createSelector } from 'reselect'

/**
 * Legacy code for retrieving non-rollouts Optimizely variants
 */

export const getFeatures = ({ features }) => features

export const getNextDayDeliveryPaintedDoorFeatureEnabled = ({ features }) => (
  features
    ? features.getIn(['nextDayDeliveryPaintedDoor', 'value'])
    : false
)

export const getNDDFeatureValue = ({ features }) => features.getIn(['ndd', 'value'])

export const getLogoutUserDisabledSlots = ({ features }) =>
  (features ? features.getIn(['logoutUserDisabledSlots', 'value']) : '')

export const getGoToMyGousto = ({ features }) =>
  (features ? features.getIn(['goToMyGousto', 'value']) : false)

export const getGoToMyDeliveries = ({ features }) =>
  (features ? features.getIn(['goToMyDeliveries', 'value']) : false)

export const isShowNoDiscountCTAFeatureEnabled = ({ features }) =>
  features && features.getIn(['showNoDiscountCTA', 'value'], false)

export const isSubscriptionPauseOsrFeatureEnabled = ({ features }) =>
  features && features.getIn(['subscriptionPauseOsr', 'value'], false)

export const isOsrOfferFeatureEnabled = ({ features }) =>
  features && features.getIn(['enableOsrOffer', 'value'], false)

export const getPromoBannerEnabled = ({ features }) =>
  features && features.getIn(['promoBanner', 'value'], true)

export const getFullScreenBoxSummary = ({ features }) =>
  features && features.getIn(['fullScreenBoxSummary', 'value'], false)

export const getIsCommunicationPanelEnabled = ({ features }) =>
  features && features.getIn(['isCommunicationPanelEnabled', 'value'], false)

export const getIsMobileTopBannerAppAwarenessEnabled = ({ features }) =>
  features && features.getIn(['isMobileTopBannerAppAwarenessEnabled', 'value'], false)

export const getIsMobileMenuModalAppAwarenessEnabled = ({ features }) =>
  features && features.getIn(['isMobileMenuModalAppAwarenessEnabled', 'value'], false)

export const getIsCustomNoticeEnabled = ({ features }) =>
  features && features.getIn(['isCustomNoticeEnabled', 'value'], false)

export const getIsMyGoustoBannerAppAwarenessEnabled = ({ features }) =>
  features && features.getIn(['isMyGoustoBannerAppAwarenessEnabled', 'value'], false)

export const getIsMultiSkipEnabled = ({ features }) =>
  features && features.getIn(['isMultiSkipEnabled', 'value'], false)

export const getIsSubscriberPricingEnabled = ({ features }) =>
  features && features.getIn(['isSubscriberPricingEnabled', 'value'], false)

export const getIsMyGoustoBannerSubscriberPricingEnabled = ({ features }) =>
  features && features.getIn(['isMyGoustoBannerSubscriberPricingEnabled', 'value'], false)

export const getIsGoustoOnDemandEnabled = ({ features }) =>
  features && features.getIn(['isGoustoOnDemandEnabled', 'value'], false)

export const getIsCorporateEnquiriesLinkVisible = ({ features }) =>
  features && features.getIn(['isCorporateEnquiriesLinkVisible', 'value'], true)

export const getIsBackClosesModalEnabled = createSelector(getFeatures, (features) =>
  features.getIn(['isBackClosesModalEnabled', 'value'], false),
)

// Beetroots active experiment: https://gousto.atlassian.net/browse/TG-7369
export const getIsCheckoutRefactoredEnabled = ({ features }) =>
  features && features.getIn(['beetrootsIsCheckoutRefactoredEnabled', 'value'], false)

// Beetroots active experiment: https://gousto.atlassian.net/browse/TG-7736
export const getIsCuratedBoxesEnabled = ({ features }) =>
  features && features.getIn(['beetrootsIsCuratedBoxesEnabled', 'value'], false)

// FE flag for all 1-3-5 portions epics across all domains
export const getIsOneThreeFivePortionsEnabled = ({ features }) =>
  features && features.getIn(['isOneThreeFivePortionsEnabled', 'value'], false)

// Beetroots active experiment: https://gousto.atlassian.net/browse/TG-8015
export const getIsBuildYourBoxCtaEnabled = ({ features }) =>
  features && features.getIn(['beetrootsIsBuildYourBoxCtaEnabled', 'value'], false)

// Beetroots upcoming experiment: https://gousto.atlassian.net/browse/TG-7835
export const getIsDiscountOptimisationEnabled = ({ features }) =>
  features && features.getIn(['beetrootsIsDiscountOptimisationEnabled', 'value'], false)

// Beetroots active experiment: https://gousto.atlassian.net/browse/TG-8055
export const getIsLandOnMenuEnabled = ({ features }) =>
  features && features.getIn(['beetrootsIsLandOnMenuEnabled', 'value'], false)
